import { createFileRoute, redirect } from '@tanstack/react-router'

// Old path: shared links and bookmarks still point here.
export const Route = createFileRoute('/_authenticated/discover')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/explore', search: search as never, replace: true })
  },
})
